
















import { Component, Vue, Prop } from "vue-property-decorator";
import {
	ParticaErrorData
} from "../../../Models/Components.model";
import ParticaDialogCard from "@/Ui-Components/Common/Container/ParticaDialogCard.vue";
import { eParticaAction, ParticaEvent } from "../../../Models/ParticaEvent";



@Component({
	name: "ParticaError",
	components: { ParticaDialogCard }
})
export default class ParticaError extends Vue {
	@Prop() public errorinfo: ParticaErrorData; // your data
	@Prop() public showerror: boolean;

	private close() {
		this.$emit("close", {
			action: eParticaAction.NONE,
			item: null
		} as ParticaEvent);
	}

	private formatMessage(message: string): string {
		// @ts-ignore
		this.$appInsights.trackException(this.errorinfo.error, `${this.$store.state.config.user}:${this.errorinfo.component}`);
		return message.replace(/(?:\r\n|\r|\n)/g, "<br>");
	}
}
